import { writable } from "svelte/store";
export let transferStore  = writable();
export const tasksStore = writable([]);
export let readyToLoadStore = writable();
export default transferStore;